/*
 * Lystia · Улюблене (T-E2-10, A-003): localStorage `lystia:fav` = { "<handle>": <expiry ms> }.
 * Термін 30 днів від додавання (фіксований); прострочені записи відкидаються при кожному читанні.
 * У UI термін не обіцяти (Safari ITP, PRD R-11). API: window.LystiaFavorites. Подія document: fav:change
 * {handle, active, reason}. Тост/тексти - окремі компоненти (слухають fav:change; reason 'toggle').
 * Розмітка: кнопка [data-fav-toggle] або .pcard__fav всередині [data-handle]; необовʼязкові
 * data-label-add / data-label-remove для aria-label (тексти з locales).
 */
(function () {
  'use strict';

  var KEY = 'lystia:fav';
  var TTL = 30 * 24 * 3600 * 1000;
  var memory = {};
  var BTN = '[data-fav-toggle], .pcard__fav';

  function readRaw() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var parsed = raw ? JSON.parse(raw) : {};
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (e) {
      return Object.assign({}, memory);
    }
  }

  function writeRaw(map) {
    memory = Object.assign({}, map);
    try { window.localStorage.setItem(KEY, JSON.stringify(map)); } catch (e) { /* приватний режим: лишається памʼять */ }
  }

  /* Читання з очищенням прострочених записів. */
  function load() {
    var raw = readRaw(), now = Date.now(), out = {}, dirty = false;
    Object.keys(raw).forEach(function (h) {
      if (typeof raw[h] === 'number' && raw[h] > now) out[h] = raw[h]; else dirty = true;
    });
    if (dirty) writeRaw(out);
    return out;
  }

  class LystiaFavoritesService {
    constructor() {
      var self = this;
      this.ttl = TTL;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest(BTN);
        if (!btn) return;
        var holder = btn.closest('[data-handle]');
        var handle = btn.getAttribute('data-handle') || (holder && holder.getAttribute('data-handle'));
        if (!handle) return;
        e.preventDefault();
        self.toggle(handle);
      });
      window.addEventListener('storage', function (e) {
        if (e.key === KEY || e.key === null) self.syncAll();
      });
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { self.syncAll(); });
      else this.syncAll();
      document.addEventListener('shopify:section:load', function () { self.syncAll(); });
    }

    has(handle) { return Object.prototype.hasOwnProperty.call(load(), handle); }
    list() { return Object.keys(load()); }
    count() { return this.list().length; }

    commit(map, handle, active, reason) {
      writeRaw(map);
      this.sync(handle, active);
      document.dispatchEvent(new CustomEvent('fav:change', { detail: { handle: handle, active: active, reason: reason || 'api' } }));
    }

    add(handle, reason) {
      var map = load();
      map[handle] = Date.now() + TTL;
      this.commit(map, handle, true, reason);
    }

    remove(handle, reason) {
      var map = load();
      delete map[handle];
      this.commit(map, handle, false, reason);
    }

    /* → новий стан (true = в улюбленому). */
    toggle(handle) {
      var on = !this.has(handle);
      if (on) this.add(handle, 'toggle'); else this.remove(handle, 'toggle');
      return on;
    }

    clear() {
      var self = this;
      this.list().forEach(function (h) { self.remove(h, 'clear'); });
    }

    /* ---------- DOM ---------- */
    buttonsFor(handle) {
      var sel = '[data-handle="' + (window.CSS && CSS.escape ? CSS.escape(handle) : handle) + '"]';
      var out = [];
      document.querySelectorAll(sel).forEach(function (holder) {
        if (holder.matches(BTN)) out.push(holder);
        holder.querySelectorAll(BTN).forEach(function (b) { if (!b.hasAttribute('data-handle') || b.getAttribute('data-handle') === handle) out.push(b); });
      });
      return out;
    }

    paint(btn, active) {
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = btn.getAttribute(active ? 'data-label-remove' : 'data-label-add');
      if (label) btn.setAttribute('aria-label', label);
    }

    sync(handle, active) {
      var self = this;
      this.buttonsFor(handle).forEach(function (b) { self.paint(b, active); });
    }

    syncAll() {
      var self = this, map = load();
      document.querySelectorAll(BTN).forEach(function (btn) {
        var holder = btn.closest('[data-handle]');
        var handle = btn.getAttribute('data-handle') || (holder && holder.getAttribute('data-handle'));
        if (handle) self.paint(btn, Object.prototype.hasOwnProperty.call(map, handle));
      });
    }
  }

  window.LystiaFavorites = window.LystiaFavorites || new LystiaFavoritesService();
})();
